"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Dialogbox = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireDefault(require("react"));

require("../dist/dialogbox.css");

var Dialogbox = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2.default)(Dialogbox, _React$Component);

  function Dialogbox() {
    (0, _classCallCheck2.default)(this, Dialogbox);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(Dialogbox).apply(this, arguments));
  }

  (0, _createClass2.default)(Dialogbox, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          title = _this$props.title,
          closeDialog = _this$props.closeDialog,
          submitDialog = _this$props.submitDialog,
          successButton = _this$props.successButton,
          cancelButton = _this$props.cancelButton,
          children = _this$props.children,
          dialogBoxID = _this$props.dialogBoxID;
      return _react.default.createElement("div", {
        "aria-labelledby": "dialog-title",
        className: "dialog",
        role: "dialog",
        id: dialogBoxID
      }, _react.default.createElement("div", {
        className: "dialog-window",
        role: "action"
      }, _react.default.createElement("div", {
        className: "dialog-header",
        role: "banner"
      }, _react.default.createElement("h2", {
        className: "dialog-title"
      }, title), _react.default.createElement("a", {
        className: "dialog-close",
        onClick: closeDialog
      }, "\xD7")), _react.default.createElement("div", {
        className: "dialog-body"
      }, _react.default.createElement("div", {
        className: "dialog-content"
      }, children), _react.default.createElement("div", {
        className: "dialog-footer"
      }, _react.default.createElement("button", {
        type: "button",
        className: "btn",
        onClick: submitDialog
      }, successButton, " "), _react.default.createElement("button", {
        type: "button",
        onClick: closeDialog,
        className: "btn"
      }, cancelButton)))), _react.default.createElement("div", {
        className: "dialog-mask"
      }));
    }
  }]);
  return Dialogbox;
}(_react.default.Component);

exports.Dialogbox = Dialogbox;